import { render, staticRenderFns } from "./DashboardManagement.vue?vue&type=template&id=34c1fc7d&scoped=true&"
import script from "./DashboardManagement.vue?vue&type=script&lang=js&"
export * from "./DashboardManagement.vue?vue&type=script&lang=js&"
import style0 from "./DashboardManagement.vue?vue&type=style&index=0&id=34c1fc7d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c1fc7d",
  null
  
)

export default component.exports